
import { ActionTree, ActionContext } from 'vuex'
import { RootState, useStore } from '@/store'
import { state, UserState } from './state'
import { Mutations } from './mutations'
import { UserMutationTypes } from './mutation-types'
import { UserActionTypes } from './action-types'
import { loginRequest, userInfoRequest } from '@/apis/getToken'
import { removeToken, setToken } from '@/utils/cookies'
import { PermissionActionType } from '../permission/action-types'
import router, { resetRouter } from '@/router'
import { RouteRecordRaw } from 'vue-router'
import userImg from '@/assets/images/home/userImg.png'
import { ElMessage  } from 'element-plus';
import {getNowDate} from '@/utils/timeFormat'
import i18n from "@/locales/index";
const _t = i18n.global.t;

type AugmentedActionContext = {
  commit<K extends keyof Mutations>(
    key: K,
    payload: Parameters<Mutations[K]>[1],
  ): ReturnType<Mutations[K]>
} & Omit<ActionContext<UserState, RootState>, 'commit'>

export interface Actions {
  [UserActionTypes.ACTION_LOGIN](
    { commit }: AugmentedActionContext,
    userInfo: { username: string, password: string, company_id: string }
  ): void
  [UserActionTypes.ACTION_RESET_TOKEN](
    { commit }: AugmentedActionContext
  ): void
  [UserActionTypes.ACTION_GET_USER_INFO](
    { commit }: AugmentedActionContext
  ): void
  [UserActionTypes.ACTION_CHANGE_ROLES](
    { commit }: AugmentedActionContext, role: string
  ): void
  [UserActionTypes.ACTION_LOGIN_OUT](
    { commit }: AugmentedActionContext,
  ): void
}

export const actions: ActionTree<UserState, RootState> & Actions = {
  async [UserActionTypes.ACTION_LOGIN](
    { commit }: AugmentedActionContext,
    userInfo: { username: string, password: string, plaintext_password: string, company_id: string,forgetPassword:any }
  ) {
    let { username, password, plaintext_password, company_id,forgetPassword } = userInfo
    company_id = company_id.trim()
    await loginRequest({ username, password, company_id,forgetPassword }).then(async(res) => {
      console.log('res=======>',res)
      if (res?.code == 200) {
        setToken(res.data.token)
        commit(UserMutationTypes.SET_TOKEN, res.data.token)
        router
        .push({
          // path: state.redirect || '/robot/robotList',
          path: '/home/Homes'
        })
        .catch(err => {
          console.warn(err)
        })
      // 存用户信息和登录时间
      let personalInfoObj = {
        company_id: company_id,
        username: username,
        loginTime: getNowDate()
      }
      localStorage.setItem('userInfo', JSON.stringify(personalInfoObj))
      // Just to simulate the time of the request
      // 记住密码 就存储账号 密码 企业号
      if (forgetPassword) {
        let obj = {
          cacheEnterprise: company_id,
          cacheUser:username,
          cachePassword:plaintext_password,
          forgetPasswordFlag:forgetPassword
        }
        localStorage.setItem('cacheObj', JSON.stringify(obj))
      } else {
        localStorage.setItem('cacheObj', '')

      }
      } else {
        function getmsg(res:any) {
          if (res.code == 40001 ) {
             return _t('login.enterpriseerror')
          } else if (res.code== 40003) {
            return _t('login.actpaswdinco')
          }
        }
        ElMessage({
          type: 'error',
          message: getmsg(res)
        })
      }
    })
  },

  [UserActionTypes.ACTION_RESET_TOKEN](
    { commit }: AugmentedActionContext) {
    removeToken()
    commit(UserMutationTypes.SET_TOKEN, '')
    commit(UserMutationTypes.SET_ROLES, [])
  },

  async [UserActionTypes.ACTION_GET_USER_INFO](
    { commit }: AugmentedActionContext
  ) {
    if (state.token === '') {
      throw Error('token is undefined!')
    }
    await userInfoRequest().then((res: any) => {
      console.log('res=>', res)
      if (res?.code == 200) {
        const roles = ['admin']

        commit(UserMutationTypes.SET_ROLES, roles)
        commit(UserMutationTypes.SET_NAME, res.data.username)
        commit(UserMutationTypes.SET_AVATAR, userImg)
        commit(UserMutationTypes.SET_ACCOUT, res.data)
        // commit(UserMutationTypes.SET_INTRODUCTION, res.data.introduction)
        // commit(UserMutationTypes.SET_EMAIL, res.data.email)
        return res
      } else {
        throw Error('Verification failed, please Login again.')
      }
    }).catch(err=>{
      console.log(err,'错误')
      // ElMessage({
      //   type:'error',
      //   message:'token失效,请重新登录',
      //   duration: 2500,
      //   onClose:()=> {
      //     router.push('/login')
      //   },
      // })
    })
  },

  async [UserActionTypes.ACTION_CHANGE_ROLES](
    { commit }: AugmentedActionContext,
    role: string
  ) {
    const token = role + '-token'
    const store = useStore()
    commit(UserMutationTypes.SET_TOKEN, token)
    setToken(token)
    await store.dispatch(UserActionTypes.ACTION_GET_USER_INFO, undefined)
    store.dispatch(PermissionActionType.ACTION_SET_ROUTES, state.roles)
    store.state.permission.dynamicRoutes.forEach((item: RouteRecordRaw) => {
      router.addRoute(item)
    })
  },

  [UserActionTypes.ACTION_LOGIN_OUT](
    { commit }: AugmentedActionContext
  ) {
    console.log(commit)
    removeToken()
    commit(UserMutationTypes.SET_TOKEN, '')
    commit(UserMutationTypes.SET_ROLES, [])
    resetRouter()
  }
}
